


import React from 'react';
import Typography from "@mui/material/Typography";


export default ({hoveredBar, scales}) => {
    const { xScale, yScale } = scales;

    const styles = {
        left: `${xScale(hoveredBar.d)-30}px`,
        top: `${yScale(hoveredBar.value)-20}px`
    };

        let val = hoveredBar.d;
        if(typeof hoveredBar.d === 'boolean'){val = JSON.stringify(hoveredBar.d)}
        else if(hoveredBar.d === ""){ val = "NA"}


        return <Typography variant={"subtitle2"}>{ val } : {hoveredBar.value} </Typography>


}

